module.exports = __webpack_public_path__ + "static/media/ic-alert.ce589575.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/ic-alert.svg
// module id = 878
// module chunks = 0